import { Check } from 'lucide-react';
import styled from 'styled-components';

import { Button } from '../../../components/atoms/button/button';
import { Modal } from '../../../components/molecules/modal/modal';
import { SaqueDetail } from '../../../types/saque';
import { formatMoney } from './format';

interface Props {
  isOpen: boolean;
  saque: SaqueDetail | null;
  loading?: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

const Summary = styled.dl`
  margin: 0;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 16px;
  padding: 12px 0 4px;

  dt {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 13px;
  }
  dd {
    margin: 0;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 13.5px;
    font-weight: 500;
  }
`;

const ErrorAlert = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.dangerBg};
  border-left: 3px solid ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.danger};
  font-size: 13px;
`;

export const ConfirmSaqueModal = ({
  isOpen,
  saque,
  loading,
  errorMessage,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Confirmar saque"
    description="Esta ação aprova o pagamento ao cliente. Tem certeza?"
    size="sm"
    footer={
      <>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          loading={loading}
          startIcon={!loading ? <Check size={14} /> : undefined}
          data-testid="confirm-action"
        >
          {loading ? 'Confirmando…' : 'Confirmar saque'}
        </Button>
      </>
    }
  >
    {saque && (
      <Summary>
        <dt>Cliente</dt>
        <dd>
          {saque.cliente.nome} {saque.cliente.sobrenome ?? ''}
        </dd>
        <dt>E-mail</dt>
        <dd>{saque.cliente.email}</dd>
        <dt>Valor</dt>
        <dd>{formatMoney(saque.valor, saque.moeda)}</dd>
        <dt>Moeda destino</dt>
        <dd>{saque.moedaDestinoSigla}</dd>
      </Summary>
    )}
    {errorMessage && <ErrorAlert role="alert">{errorMessage}</ErrorAlert>}
  </Modal>
);
